import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import {
  SelectedProduct,
  SlotService,
  V3Product,
} from '../../../../../utils/state/types';
import { SelectedAddons } from './SelectedAddons';
import { SelectedRelatedProducts } from './SelectedRelatedProducts';
import { ExpandableDetails } from './ExpandableDetails';
import { classes } from './MoreDetails.st.css';
import { SingleSlotDetailsDataHook } from './dataHooks';
import Duration from '../../Duration/Duration';
import StaffMembers from '../../StaffMembers/StaffMembers';
import Location from '../../Location/Location';
import { FormNestedSlot } from '../../../../../types/formSelectedSlots';

export type MoreDetailsProps = {
  slotService: SlotService;
  slot: FormNestedSlot;
  isSingleService: boolean;
  selectedProductAddons?: SelectedProduct[];
  relatedProducts?: V3Product[];
  // When true, the details are always visible without the expand/collapse
  // accordion (used on mobile).
  alwaysExpanded?: boolean;
};
export const MoreDetails: React.FC<MoreDetailsProps> = ({
  slotService,
  slot,
  isSingleService,
  selectedProductAddons,
  relatedProducts,
  alwaysExpanded = false,
}) => {
  const {
    service,
    resourceSelections,
    addOnByGroup,
    selectedAddons,
    participants,
    paymentDetails,
  } = slotService;

  const hasSharedAddons =
    !!selectedAddons && Object.keys(selectedAddons).length > 0;
  // Several participants: add-ons are listed per participant in Payment Details.
  const hasParticipantAddons =
    participants?.length === 1 &&
    Object.keys(participants[0].selectedAddons ?? {}).length > 0;
  const hasAddons = !!addOnByGroup && (hasSharedAddons || hasParticipantAddons);
  const renderContent = () => {
    return (
      <>
        <Location location={service.location} />
        <StaffMembers
          service={service}
          resourceSelections={resourceSelections}
        />
        <Duration
          slotService={slotService}
          slot={slot}
          totalNumberOfSessions={service.totalNumberOfSessions}
          remainingNumberOfSessions={service.remainingNumberOfSessions}
        />
        {hasAddons && <SelectedAddons slotService={slotService} />}
        <SelectedRelatedProducts
          selectedProductAddons={selectedProductAddons}
          relatedProducts={relatedProducts}
          paymentDetails={paymentDetails}
        />
      </>
    );
  };

  if (alwaysExpanded) {
    return (
      <div data-hook={SingleSlotDetailsDataHook.MORE_DETAILS}>
        {renderContent()}
      </div>
    );
  }

  return (
    <div data-hook={SingleSlotDetailsDataHook.MORE_DETAILS}>
      <ExpandableDetails>{renderContent()}</ExpandableDetails>
      {isSingleService && <Divider className={classes.divider} />}
    </div>
  );
};
